var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "material-notification__item__info" }, [
    _c("span", { domProps: { innerHTML: _vm._s(_vm.data.content) } }),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("ui-button", {
          attrs: { text: _vm.data.closeButtonText || "Close" },
          on: { click: _vm.onClose },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }